import React, { createContext, useContext, useEffect, useState } from "react";
import logo from "../logo.svg";
import darkLogo from "../assets/images/logo-light.svg";
import leftArrow from "../assets/images/left-arrow.svg";
import rightArrow from "../assets/images/right-arrow.svg";
import ellipseTop from "../assets/images/ellipse-top.svg";
import { useNavigate, useSearchParams } from "react-router-dom";
import { MenuContext } from "../pages/Layout";
import { Link } from "react-router-dom";
import { ThemeContext } from "../state/ThemeContext";
import { useUser } from "../state/UserContext";
import { fetchNbOfBoards } from "../services/boardService";
const SidebarContext = createContext();
const Sidebar = () => {
  const [searchParams] = useSearchParams();

  const { userData, setUser } = useUser();
  const { currentThemeColor, setCurrentThemeColor } = useUser();
  const { theme } = useContext(ThemeContext);

  // const { userData } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    const myParam = searchParams.get("data");
    if (myParam != null) {
      const { user, token } = JSON.parse(myParam);
      setUser(JSON.parse(myParam));
      localStorage.setItem("user", JSON.stringify(user));
      localStorage.setItem("token", token);
      setCurrentThemeColor(localStorage.getItem("theme-color"));
      // window.location.href = '/dashboard';
      navigate("/home-dashboard");
    }
  }, []);

  const iconStyle = {
    stroke:
      theme === "light"
        ? localStorage.getItem("theme-color-light") || userData.themeColor
        : userData.themeColor === "#000000"
        ? localStorage.getItem("theme-color-input") || userData.themeColor
        : localStorage.getItem("theme-color") || userData.themeColor,

    "&:hover": {
      stroke: localStorage.getItem("theme-color") || userData.themeColor,
      color: localStorage.getItem("theme-color") || userData.themeColor,
    },
    "&.active": {
      stroke: localStorage.getItem("theme-color") || userData.themeColor,
      color: localStorage.getItem("theme-color") || userData.themeColor,
    },
  };

  const iconStyle2 = {
    fill:
      theme === "light"
        ? localStorage.getItem("theme-color-light") || userData.themeColor
        : userData.themeColor === "#000000"
        ? localStorage.getItem("theme-color-input") || userData.themeColor
        : localStorage.getItem("theme-color") || userData.themeColor,
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const sidebarItems = [
    {
      text: "Home",
      to: "/home-dashboard",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 25 25"
          fill="none"
          className="icon"
        >
          <path
            d="M16.5 15.291C14.29 16.624 10.708 16.624 8.5 15.291M19.5 9.00078L14.167 4.85278C13.699 4.48869 13.123 4.29102 12.53 4.29102C11.937 4.29102 11.361 4.48869 10.893 4.85278L5.559 9.00078C5.23844 9.25007 4.97909 9.56931 4.80075 9.93413C4.62242 10.299 4.52981 10.6997 4.53 11.1058V18.3058C4.53 18.8362 4.74071 19.3449 5.11579 19.72C5.49086 20.0951 5.99957 20.3058 6.53 20.3058H18.53C19.0604 20.3058 19.5691 20.0951 19.9442 19.72C20.3193 19.3449 20.53 18.8362 20.53 18.3058V11.1058C20.53 10.2828 20.15 9.50578 19.5 9.00078Z"
            style={iconStyle}
            stroke="#168004"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
    {
      text: "Dashboards",
      to: "/dashboards",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
          className="icon"
        >
          <path
            d="M21.5 14H14.5V21H21.5V14Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
          <path
            d="M10.5 14H3.5V21H10.5V14Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
          <path
            d="M21.5 3H14.5V10H21.5V3Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
          <path
            d="M10.5 3H3.5V10H10.5V3Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
        </svg>
      ),
    },
    {
      text: "Real Time Data",
      to: "/realtime-data",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <path
            d="M16.5 18.959C16.7984 18.959 17.0845 18.8405 17.2955 18.6295C17.5065 18.4185 17.625 18.1324 17.625 17.834C17.625 17.5356 17.5065 17.2495 17.2955 17.0385C17.0845 16.8275 16.7984 16.709 16.5 16.709V18.959ZM7.5 16.709C7.20163 16.709 6.91548 16.8275 6.7045 17.0385C6.49353 17.2495 6.375 17.5356 6.375 17.834C6.375 18.1324 6.49353 18.4185 6.7045 18.6295C6.91548 18.8405 7.20163 18.959 7.5 18.959V16.709ZM8.29537 6.91361C8.1916 6.80616 8.06746 6.72046 7.9302 6.6615C7.79295 6.60254 7.64533 6.5715 7.49595 6.5702C7.34657 6.5689 7.19844 6.59737 7.06018 6.65393C6.92192 6.7105 6.79631 6.79404 6.69068 6.89966C6.58505 7.00529 6.50152 7.1309 6.44495 7.26916C6.38838 7.40742 6.35992 7.55556 6.36122 7.70494C6.36252 7.85431 6.39355 8.00193 6.45251 8.13919C6.51147 8.27644 6.59718 8.40058 6.70463 8.50436L8.29537 6.91361ZM10.875 11.084L11.6704 11.8794C11.8813 11.6684 11.9998 11.3823 11.9998 11.084C11.9998 10.7857 11.8813 10.4996 11.6704 10.2886L10.875 11.084ZM6.70463 13.6636C6.59718 13.7674 6.51147 13.8915 6.45251 14.0288C6.39355 14.166 6.36252 14.3137 6.36122 14.463C6.35992 14.6124 6.38838 14.7605 6.44495 14.8988C6.50152 15.0371 6.58505 15.1627 6.69068 15.2683C6.79631 15.3739 6.92192 15.4575 7.06018 15.514C7.19844 15.5706 7.34657 15.5991 7.49595 15.5978C7.64533 15.5965 7.79295 15.5654 7.9302 15.5065C8.06746 15.4475 8.1916 15.3618 8.29537 15.2544L6.70463 13.6636ZM6.375 3.20898H17.625V0.958984H6.375V3.20898ZM21 6.58398V17.834H23.25V6.58398H21ZM17.625 21.209H6.375V23.459H17.625V21.209ZM3 17.834V6.58398H0.75V17.834H3ZM6.375 21.209C5.47989 21.209 4.62145 20.8534 3.98851 20.2205C3.35558 19.5875 3 18.7291 3 17.834H0.75C0.75 19.3258 1.34263 20.7566 2.39752 21.8115C3.45242 22.8664 4.88316 23.459 6.375 23.459V21.209ZM21 17.834C21 18.7291 20.6444 19.5875 20.0115 20.2205C19.3786 20.8534 18.5201 21.209 17.625 21.209V23.459C19.1168 23.459 20.5476 22.8664 21.6025 21.8115C22.6574 20.7566 23.25 19.3258 23.25 17.834H21ZM17.625 3.20898C18.5201 3.20898 19.3786 3.56456 20.0115 4.1975C20.6444 4.83043 21 5.68888 21 6.58398H23.25C23.25 5.09214 22.6574 3.6614 21.6025 2.60651C20.5476 1.55162 19.1168 0.958984 17.625 0.958984V3.20898ZM6.375 0.958984C4.88316 0.958984 3.45242 1.55162 2.39752 2.60651C1.34263 3.6614 0.75 5.09214 0.75 6.58398H3C3 5.68888 3.35558 4.83043 3.98851 4.1975C4.62145 3.56456 5.47989 3.20898 6.375 3.20898V0.958984ZM16.5 16.709H7.5V18.959H16.5V16.709ZM6.70463 8.50436L10.0796 11.8794L11.6704 10.2886L8.29537 6.91361L6.70463 8.50436ZM10.0796 10.2886L6.70463 13.6636L8.29537 15.2544L11.6704 11.8794L10.0796 10.2886Z"
            fill="#5C5C5C"
            style={iconStyle2}
          />
        </svg>
      ),
    },
    {
      text: "Boards",
      to: "/manage-boards",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="29"
          height="28"
          viewBox="0 0 29 28"
          fill="none"
          className="icon"
        >
          <path
            d="M21.2817 9.38184V5.91821C21.2817 5.61201 21.1601 5.31835 20.9436 5.10183C20.7271 4.88531 20.4334 4.76367 20.1272 4.76367H5.11816C4.81196 4.76367 4.5183 4.88531 4.30178 5.10183C4.08526 5.31835 3.96362 5.61201 3.96362 5.91821V19.7727C3.96362 20.0789 4.08526 20.3726 4.30178 20.5891C4.5183 20.8056 4.81196 20.9272 5.11816 20.9272H15.509M18.9727 10.5364H21.2817M16.6636 9.38184H23.5908C24.2285 9.38184 24.7454 9.89874 24.7454 10.5364V22.0818C24.7454 22.7194 24.2285 23.2363 23.5908 23.2363H16.6636C16.0259 23.2363 15.509 22.7194 15.509 22.0818V10.5364C15.509 9.89874 16.0259 9.38184 16.6636 9.38184Z"
            stroke="#5C5C5C"
            strokeWidth="1.88925"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
        </svg>
      ),
    },
    {
      text: "Sensors",
      to: "/manage-sensors",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="24"
          viewBox="0 0 25 24"
          fill="none"
        >
          <g clipPath="url(#clip0_595_4058)">
            <path
              d="M23.19 18.37L24.33 17.37L23.33 15.64L21.88 16.13C21.5589 15.8594 21.1936 15.6463 20.8 15.5L20.5 14H18.5L18.2 15.49C17.8064 15.6362 17.441 15.8494 17.12 16.12L15.67 15.63L14.67 17.36L15.81 18.36C15.73 18.7762 15.73 19.2038 15.81 19.62L14.67 20.62L15.67 22.35L17.12 21.86C17.441 22.1306 17.8064 22.3438 18.2 22.49L18.5 24H20.5L20.8 22.51C21.1936 22.3638 21.559 22.1506 21.88 21.88L23.33 22.37L24.33 20.64L23.19 19.64C23.27 19.2204 23.27 18.7896 23.19 18.37ZM19.5 21C19.1044 21 18.7178 20.8827 18.3889 20.6629C18.06 20.4432 17.8036 20.1308 17.6522 19.7654C17.5009 19.3999 17.4613 18.9978 17.5384 18.6098C17.6156 18.2219 17.8061 17.8655 18.0858 17.5858C18.3655 17.3061 18.7219 17.1156 19.1098 17.0384C19.4978 16.9613 19.8999 17.0009 20.2654 17.1522C20.6308 17.3036 20.9432 17.56 21.1629 17.8889C21.3827 18.2178 21.5 18.6044 21.5 19C21.4984 19.5299 21.2872 20.0377 20.9125 20.4125C20.5377 20.7872 20.0299 20.9984 19.5 21ZM23.5 11H1.5V1H23.5V11ZM3.5 9H21.5V3H3.5V9ZM13.5 5H4.5V7H13.5V5ZM16.5 5C16.3022 5 16.1089 5.05865 15.9444 5.16853C15.78 5.27841 15.6518 5.43459 15.5761 5.61732C15.5004 5.80004 15.4806 6.00111 15.5192 6.19509C15.5578 6.38907 15.653 6.56725 15.7929 6.70711C15.9327 6.84696 16.1109 6.9422 16.3049 6.98078C16.4989 7.01937 16.7 6.99957 16.8827 6.92388C17.0654 6.84819 17.2216 6.72002 17.3315 6.55557C17.4414 6.39112 17.5 6.19778 17.5 6C17.5 5.73478 17.3946 5.48043 17.2071 5.29289C17.0196 5.10536 16.7652 5 16.5 5ZM19.5 5C19.3022 5 19.1089 5.05865 18.9444 5.16853C18.78 5.27841 18.6518 5.43459 18.5761 5.61732C18.5004 5.80004 18.4806 6.00111 18.5192 6.19509C18.5578 6.38907 18.653 6.56725 18.7929 6.70711C18.9327 6.84696 19.1109 6.9422 19.3049 6.98078C19.4989 7.01937 19.7 6.99957 19.8827 6.92388C20.0654 6.84819 20.2216 6.72002 20.3315 6.55557C20.4414 6.39112 20.5 6.19778 20.5 6C20.5 5.73478 20.3946 5.48043 20.2071 5.29289C20.0196 5.10536 19.7652 5 19.5 5Z"
              fill="#5C5C5C"
              style={iconStyle2}
            />
            <path
              d="M12.794 21H3.5V15H13.76C14.3272 14.1896 15.0592 13.508 15.908 13H1.5V23H13.76C13.333 22.3893 13.0069 21.7141 12.794 21Z"
              fill="#5C5C5C"
              style={iconStyle2}
            />
            <path
              d="M4.5 19H12.5C12.5006 18.3226 12.5997 17.6489 12.794 17H4.5V19Z"
              fill="#5C5C5C"
              style={iconStyle2}
            />
          </g>
          <defs>
            <clipPath id="clip0_595_4058">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="translate(0.5)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      text: "Activity Logs",
      to: "/activity-log",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          stroke="#00000"
          strokeWidth="2px"
        >
          <g clipPath="url(#clip0_2181_32663)">
            <path
              d="M3.01223 18.1354C3.42768 17.8264 4.01493 17.9127 4.32398 18.328C4.49395 18.5565 4.67582 18.7806 4.86459 18.9941C5.20748 19.382 5.17106 19.9745 4.78317 20.3175C4.60476 20.4752 4.38328 20.5526 4.16259 20.5526C3.90328 20.5526 3.64509 20.4456 3.45984 20.236C3.23629 19.9832 3.0209 19.7177 2.81962 19.4471C2.51057 19.0318 2.59678 18.4444 3.01223 18.1354Z"
              style={iconStyle2}
            />
            <path
              d="M1.44436 13.7388C1.94995 13.6287 2.44968 13.9495 2.55979 14.4554C2.6204 14.7337 2.69362 15.0125 2.77758 15.2842C2.93043 15.7789 2.65331 16.3038 2.15864 16.4567C2.06643 16.4852 1.97325 16.4987 1.88156 16.4987C1.48125 16.4987 1.11056 16.2402 0.986153 15.8377C0.886497 15.5153 0.79959 15.1844 0.727684 14.8542C0.617574 14.3484 0.938434 13.849 1.44436 13.7388Z"
              style={iconStyle2}
            />
            <path
              d="M7.52474 21.1379C7.77365 21.2769 8.03137 21.4067 8.29068 21.5238C8.76257 21.7369 8.97234 22.2922 8.75924 22.7641C8.60268 23.1108 8.26148 23.316 7.90429 23.316C7.77529 23.316 7.64418 23.2892 7.51898 23.2327C7.21134 23.0937 6.90581 22.9397 6.61068 22.775C6.15857 22.5226 5.99671 21.9515 6.24918 21.4994C6.50151 21.0474 7.07264 20.8855 7.52474 21.1379Z"
              style={iconStyle2}
            />
            <path
              d="M13.4375 4.79102V11.9027L16.8753 15.3404C17.2414 15.7066 17.2414 16.3001 16.8753 16.6662C16.6922 16.8493 16.4523 16.9408 16.2123 16.9408C15.9724 16.9408 15.7325 16.8493 15.5494 16.6662L11.8371 12.9539C11.6613 12.7781 11.5625 12.5396 11.5625 12.291V4.79102C11.5625 4.27323 11.9822 3.85352 12.5 3.85352C13.0178 3.85352 13.4375 4.27323 13.4375 4.79102Z"
              style={iconStyle2}
            />
            <path
              d="M1.4375 2.30664C1.95528 2.30664 2.375 2.72636 2.375 3.24414V5.84739C4.55713 2.42514 8.36792 0.291016 12.5 0.291016C15.7053 0.291016 18.7188 1.53925 20.9853 3.8057C23.2518 6.07225 24.5 9.0857 24.5 12.291C24.5 15.4963 23.2518 18.5098 20.9853 20.7763C18.7188 23.0428 15.7053 24.291 12.5 24.291C12.4921 24.291 12.4844 24.29 12.4766 24.2898C12.4687 24.29 12.461 24.291 12.4531 24.291C12.1152 24.291 11.774 24.2768 11.4389 24.2487C10.9229 24.2055 10.5397 23.7522 10.5829 23.2363C10.6261 22.7203 11.0788 22.3369 11.5954 22.3803C11.8787 22.404 12.1672 22.416 12.4531 22.416C12.461 22.416 12.4687 22.417 12.4766 22.4172C12.4844 22.417 12.4921 22.416 12.5 22.416C18.083 22.416 22.625 17.874 22.625 12.291C22.625 6.70806 18.083 2.16602 12.5 2.16602C8.90197 2.16602 5.59264 4.08381 3.78425 7.13477H6.36205C6.87983 7.13477 7.29955 7.55448 7.29955 8.07227C7.29955 8.59005 6.87983 9.00977 6.36205 9.00977H3.5C2.92906 9.00977 2.39492 8.84931 1.94014 8.57134C1.91089 8.55466 1.88276 8.5367 1.85595 8.51734C1.04005 7.98058 0.5 7.05728 0.5 6.00977V3.24414C0.5 2.72636 0.91972 2.30664 1.4375 2.30664Z"
              style={iconStyle2}
            />
          </g>
          <defs>
            <clipPath id="clip0_2181_32663">
              <rect
                width="24"
                height="24"
                fill="white"
                transform="matrix(-1 0 0 1 24.5 0.291016)"
              />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    // {
    //   text: "Collaborators",
    //   to: "/collaborators",
    //   svg: (
    //     <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    //     <path d="M19.8172 16.6949C19.2305 16.1078 18.5451 15.6286 17.7922 15.2793C18.8539 14.4191 19.5312 13.1066 19.5312 11.6348C19.5312 9.03789 17.3656 6.90742 14.7687 6.94727C12.2117 6.98711 10.1516 9.0707 10.1516 11.6348C10.1516 13.1066 10.8312 14.4191 11.8906 15.2793C11.1376 15.6284 10.4521 16.1076 9.86562 16.6949C8.58594 17.977 7.85937 19.6691 7.8125 21.4738C7.81187 21.4988 7.81626 21.5237 7.8254 21.547C7.83455 21.5703 7.84826 21.5915 7.86573 21.6095C7.8832 21.6274 7.90409 21.6416 7.92715 21.6513C7.95021 21.661 7.97498 21.666 8 21.666H9.3125C9.41328 21.666 9.49765 21.5863 9.5 21.4855C9.54453 20.1262 10.0953 18.8535 11.0633 17.8879C11.5586 17.3899 12.1478 16.9952 12.7967 16.7264C13.4456 16.4577 14.1414 16.3203 14.8437 16.3223C16.2711 16.3223 17.6141 16.8777 18.6242 17.8879C19.5898 18.8535 20.1406 20.1262 20.1875 21.4855C20.1898 21.5863 20.2742 21.666 20.375 21.666H21.6875C21.7125 21.666 21.7373 21.661 21.7604 21.6513C21.7834 21.6416 21.8043 21.6274 21.8218 21.6095C21.8392 21.5915 21.853 21.5703 21.8621 21.547C21.8712 21.5237 21.8756 21.4988 21.875 21.4738C21.8281 19.6691 21.1016 17.977 19.8172 16.6949ZM14.8437 14.6348C14.0422 14.6348 13.2875 14.323 12.7227 13.7559C12.4392 13.4746 12.2153 13.1392 12.0643 12.7695C11.9133 12.3999 11.8383 12.0036 11.8437 11.6043C11.8508 10.8355 12.1578 10.0926 12.6945 9.5418C13.257 8.96524 14.0094 8.64414 14.8133 8.63477C15.6078 8.62774 16.3789 8.93711 16.9461 9.49258C17.5273 10.0621 17.8461 10.8238 17.8461 11.6348C17.8461 12.4363 17.5344 13.1887 16.9672 13.7559C16.6889 14.0355 16.358 14.2571 15.9935 14.408C15.629 14.5588 15.2382 14.6359 14.8437 14.6348ZM8.97265 12.2535C8.95156 12.0496 8.93984 11.8434 8.93984 11.6348C8.93984 11.2621 8.975 10.8988 9.04062 10.5449C9.05703 10.4605 9.0125 10.3738 8.93515 10.3387C8.6164 10.1957 8.32344 9.99883 8.07031 9.75039C7.77204 9.46119 7.53734 9.11299 7.38117 8.72801C7.22499 8.34303 7.15079 7.92972 7.16328 7.51445C7.18437 6.76211 7.48672 6.04727 8.01406 5.5082C8.59297 4.91524 9.37109 4.5918 10.1984 4.60117C10.9461 4.6082 11.668 4.89648 12.2141 5.40742C12.3992 5.58086 12.5586 5.77305 12.6922 5.9793C12.7391 6.05195 12.8305 6.08242 12.9102 6.0543C13.3227 5.91133 13.7586 5.81055 14.2062 5.76367C14.3375 5.74961 14.4125 5.60898 14.3539 5.4918C13.5922 3.98477 12.0359 2.94414 10.2359 2.91602C7.63672 2.87617 5.47109 5.00664 5.47109 7.60117C5.47109 9.07305 6.14844 10.3855 7.21015 11.2457C6.46484 11.5902 5.77812 12.066 5.18281 12.6613C3.89844 13.9434 3.17187 15.6355 3.125 17.4426C3.12437 17.4676 3.12876 17.4925 3.1379 17.5158C3.14704 17.5391 3.16076 17.5603 3.17823 17.5782C3.1957 17.5961 3.21659 17.6103 3.23965 17.6201C3.2627 17.6298 3.28748 17.6348 3.3125 17.6348H4.62734C4.72812 17.6348 4.8125 17.5551 4.81484 17.4543C4.85937 16.0949 5.41015 14.8223 6.37812 13.8566C7.06719 13.1676 7.91094 12.6895 8.83203 12.4574C8.92344 12.434 8.98437 12.3473 8.97265 12.2535Z" fill="#168004"/>
    //     </svg>
    //   ),
    // },

    {
      text: "Settings",
      to: "/settings",
      svg: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 25 24"
          fill="none"
          className="icon"
        >
          <path
            d="M12.4999 14.3466C13.7959 14.3466 14.8465 13.296 14.8465 12C14.8465 10.704 13.7959 9.65344 12.4999 9.65344C11.2039 9.65344 10.1533 10.704 10.1533 12C10.1533 13.296 11.2039 14.3466 12.4999 14.3466Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
          <path
            d="M18.5545 14.4545C18.4456 14.7013 18.4131 14.9751 18.4613 15.2405C18.5094 15.5059 18.6359 15.7508 18.8245 15.9436L18.8736 15.9927C19.0258 16.1447 19.1465 16.3252 19.2288 16.5238C19.3112 16.7225 19.3536 16.9354 19.3536 17.1505C19.3536 17.3655 19.3112 17.5784 19.2288 17.7771C19.1465 17.9757 19.0258 18.1562 18.8736 18.3082C18.7217 18.4603 18.5412 18.581 18.3425 18.6634C18.1439 18.7457 17.931 18.7881 17.7159 18.7881C17.5009 18.7881 17.2879 18.7457 17.0893 18.6634C16.8906 18.581 16.7102 18.4603 16.5582 18.3082L16.5091 18.2591C16.3163 18.0705 16.0714 17.9439 15.8059 17.8958C15.5405 17.8477 15.2668 17.8802 15.02 17.9891C14.778 18.0928 14.5716 18.265 14.4263 18.4845C14.2809 18.704 14.2029 18.9613 14.2018 19.2245V19.3636C14.2018 19.7976 14.0294 20.2138 13.7225 20.5207C13.4157 20.8276 12.9994 21 12.5655 21C12.1315 21 11.7152 20.8276 11.4084 20.5207C11.1015 20.2138 10.9291 19.7976 10.9291 19.3636V19.29C10.9228 19.0192 10.8351 18.7565 10.6775 18.5362C10.5199 18.3159 10.2997 18.1481 10.0455 18.0545C9.79868 17.9456 9.52493 17.9131 9.25952 17.9613C8.9941 18.0094 8.74919 18.1359 8.55636 18.3245L8.50727 18.3736C8.3553 18.5258 8.17483 18.6465 7.97617 18.7288C7.77752 18.8112 7.56459 18.8536 7.34955 18.8536C7.1345 18.8536 6.92157 18.8112 6.72292 18.7288C6.52426 18.6465 6.34379 18.5258 6.19182 18.3736C6.03967 18.2217 5.91898 18.0412 5.83663 17.8425C5.75428 17.6439 5.71189 17.431 5.71189 17.2159C5.71189 17.0009 5.75428 16.7879 5.83663 16.5893C5.91898 16.3906 6.03967 16.2102 6.19182 16.0582L6.24091 16.0091C6.42953 15.8163 6.55606 15.5714 6.60419 15.3059C6.65231 15.0405 6.61982 14.7668 6.51091 14.52C6.40719 14.278 6.23498 14.0716 6.01547 13.9263C5.79596 13.7809 5.53873 13.7029 5.27545 13.7018H5.13636C4.70237 13.7018 4.28616 13.5294 3.97928 13.2225C3.6724 12.9157 3.5 12.4994 3.5 12.0655C3.5 11.6315 3.6724 11.2152 3.97928 10.9084C4.28616 10.6015 4.70237 10.4291 5.13636 10.4291H5.21C5.48081 10.4228 5.74346 10.3351 5.96379 10.1775C6.18412 10.0199 6.35195 9.79969 6.44545 9.54545C6.55437 9.29868 6.58686 9.02493 6.53873 8.75952C6.49061 8.4941 6.36408 8.24919 6.17545 8.05636L6.12636 8.00727C5.97422 7.8553 5.85352 7.67483 5.77118 7.47617C5.68883 7.27752 5.64644 7.06459 5.64644 6.84955C5.64644 6.6345 5.68883 6.42157 5.77118 6.22292C5.85352 6.02426 5.97422 5.84379 6.12636 5.69182C6.27834 5.53967 6.45881 5.41898 6.65746 5.33663C6.85611 5.25428 7.06905 5.21189 7.28409 5.21189C7.49913 5.21189 7.71207 5.25428 7.91072 5.33663C8.10937 5.41898 8.28984 5.53967 8.44182 5.69182L8.49091 5.74091C8.68374 5.92953 8.92865 6.05606 9.19406 6.10419C9.45948 6.15231 9.73322 6.11982 9.98 6.01091H10.0455C10.2874 5.90719 10.4938 5.73498 10.6392 5.51547C10.7846 5.29596 10.8626 5.03873 10.8636 4.77545V4.63636C10.8636 4.20237 11.036 3.78616 11.3429 3.47928C11.6498 3.1724 12.066 3 12.5 3C12.934 3 13.3502 3.1724 13.6571 3.47928C13.964 3.78616 14.1364 4.20237 14.1364 4.63636V4.71C14.1374 4.97328 14.2154 5.23051 14.3608 5.45002C14.5062 5.66953 14.7126 5.84174 14.9545 5.94545C15.2013 6.05437 15.4751 6.08686 15.7405 6.03873C16.0059 5.99061 16.2508 5.86408 16.4436 5.67545L16.4927 5.62636C16.6447 5.47422 16.8252 5.35352 17.0238 5.27118C17.2225 5.18883 17.4354 5.14644 17.6505 5.14644C17.8655 5.14644 18.0784 5.18883 18.2771 5.27118C18.4757 5.35352 18.6562 5.47422 18.8082 5.62636C18.9603 5.77834 19.081 5.95881 19.1634 6.15746C19.2457 6.35611 19.2881 6.56905 19.2881 6.78409C19.2881 6.99913 19.2457 7.21207 19.1634 7.41072C19.081 7.60937 18.9603 7.78984 18.8082 7.94182L18.7591 7.99091C18.5705 8.18374 18.4439 8.42865 18.3958 8.69406C18.3477 8.95948 18.3802 9.23322 18.4891 9.48V9.54545C18.5928 9.78745 18.765 9.99383 18.9845 10.1392C19.204 10.2846 19.4613 10.3626 19.7245 10.3636H19.8636C20.2976 10.3636 20.7138 10.536 21.0207 10.8429C21.3276 11.1498 21.5 11.566 21.5 12C21.5 12.434 21.3276 12.8502 21.0207 13.1571C20.7138 13.464 20.2976 13.6364 19.8636 13.6364H19.79C19.5267 13.6374 19.2695 13.7154 19.05 13.8608C18.8305 14.0062 18.6583 14.2126 18.5545 14.4545V14.4545Z"
            stroke="#5C5C5C"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            style={iconStyle}
          />
        </svg>
      ),
    },
  ];

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth <= 1024);
  const [isPhoneScreen, setIsPhoneScreen] = useState(window.innerWidth <= 767);
  const [expanded, setExpanded] = useState(!isSmallScreen);

  const handleItemClick = (item, index) => {
    if (item === "logout") {
      localStorage.clear();
      navigate("/login");
    } else {
      setActiveIndex(index);
    }
  };

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 1024px)");
    const mediaQueryPhone = window.matchMedia("(max-width: 767px)");

    const handleResizeTablet = (event) => {
      setIsSmallScreen(event.matches);

      if (event.matches) {
        setExpanded(false);
      } else {
        setExpanded(true);
      }
    };

    const handleResizePhone = (event) => {
      setIsPhoneScreen(event.matches);
    };

    mediaQuery.addListener(handleResizeTablet);
    mediaQueryPhone.addListener(handleResizePhone);

    // Initial check
    setIsSmallScreen(mediaQuery.matches);
    setIsPhoneScreen(mediaQueryPhone.matches);

    // Remove the listener when the component unmounts
    return () => {
      mediaQuery.removeListener(handleResizeTablet);
      mediaQueryPhone.removeListener(handleResizePhone);
    };
  }, []);

  const [mobileMenuOpen, setMobileMenuOpen] = useContext(MenuContext);

  return (
    <aside
      className={`h-screen    ${expanded ? "w-72" : "w-24"} ${
        mobileMenuOpen && isPhoneScreen && "absolute"
      } z-10`}
    >
      <nav
        className={`h-full flex flex-col  ${
          theme === "dark"
            ? "bg-[#121611] border-[#242424]"
            : "bg-white border-[#E8E8E8]"
        } border-r  shadow-sm`}
      >
        <div className="p-4 pb-[50px] pt-[32px] flex justify-between items-center">
          <img
            src={ellipseTop}
            alt="ellipse"
            className="absolute left-0 top-0"
          />

          <div
            className={` transition-all ${expanded ? "block" : "w-0 hidden"}`}
          ></div>

          {theme === "light" ? (
            <img
              src={logo}
              alt="logo"
              className={` transition-all cursor-pointer ${
                expanded ? "w-[9.25rem] h-[5rem] z-10 " : "w-0 hidden"
              }`}
              onClick={() => navigate("/")}
              loading="lazy"
            />
          ) : (
            <img
              src={darkLogo}
              alt="logo1"
              className={` transition-all cursor-pointer ${
                expanded ? "w-[9.25rem] h-[5rem] z-10 " : "w-0 hidden"
              }`}
              onClick={() => navigate("/")}
              loading="lazy"
            />
          )}

          <button
            onClick={() => setExpanded((curr) => !curr)}
            className={`p-1.5 rounded-lg bg-gray-50 hover:bg-gray-100 cursor-pointer z-10 ${
              expanded ? "" : "ml-3 border"
            } ${isPhoneScreen ? "hidden" : ""}`}
          >
            {expanded ? (
              <img src={leftArrow} alt="arrow left" />
            ) : (
              <img src={rightArrow} alt="arrow right" />
            )}
          </button>
        </div>

        {/* <ul className="flex-1 px-5">{children}</ul> */}
        <SidebarContext.Provider value={{ expanded }}>
          <ul className="flex-1 px-5 dark:text-white">
            {sidebarItems.map((item, index) => (
              <Link to={`${item.to}`} key={index}>
                <SidebarItem
                  text={item.text}
                  icon={item.svg}
                  isActive={activeIndex === index}
                  onClick={() => handleItemClick(item.text, index)}
                />
              </Link>
            ))}
          </ul>

          <div className="px-5">
            <SidebarItem
              icon={
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="20"
                  viewBox="0 0 21 20"
                  fill="none"
                  className="icon"
                >
                  <path
                    d="M8.83331 14.1667L13 10L8.83331 5.83337"
                    stroke="#5C5C5C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={iconStyle}
                  />
                  <path
                    d="M13 10H3"
                    stroke="#5C5C5C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={iconStyle}
                  />
                  <path
                    d="M13 2.5H16.3333C16.7754 2.5 17.1993 2.67559 17.5118 2.98816C17.8244 3.30072 18 3.72464 18 4.16667V15.8333C18 16.2754 17.8244 16.6993 17.5118 17.0118C17.1993 17.3244 16.7754 17.5 16.3333 17.5H13"
                    stroke="#5C5C5C"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    style={iconStyle}
                  />
                </svg>
              }
              text="Logout"
              onClick={() => handleItemClick("logout")}
            />
          </div>
        </SidebarContext.Provider>

        <div className="border-t mx-7 flex " />
        <div
          className={`mt-[24px] mx-5 flex p-3 mb-[27px] ${
            expanded ? "" : "pl-1"
          }`}
        >
          {" "}
          {userData.picture !== undefined ? (
            <img
              src={userData.picture}
              alt="avatar"
              className="w-[40px] h-[40px] rounded-[40px]"
            />
          ) : (
            <span
              style={{
                backgroundColor:
                  localStorage.getItem("theme-color") ||
                  userData.themeColor ||
                  "#168004",
              }}
              className={`w-[40px] h-[40px]  rounded-[40px] text-white text-center content-center font-bold `}
            >
              {userData.firstName.slice(0, 1).toUpperCase()}{" "}
              {userData.lastName.slice(0, 1).toUpperCase()}
            </span>
          )}
          <div
            className={`flex justify-between items-center  overflow-hidden transition-all ${
              expanded ? " ml-3 z-10" : "w-0"
            }`}
          >
            <div className="leading-4  dark:text-white">
              <h4>
                {userData.firstName} {userData.lastName}
              </h4>
            </div>
          </div>
        </div>
      </nav>
    </aside>
  );
};

export default Sidebar;

export function SidebarItem({ icon, text, onClick, isActive }) {
  const { expanded } = useContext(SidebarContext);
  const { theme } = useContext(ThemeContext);
  const { userData } = useUser();
  const themeColor = isActive ? localStorage.getItem("theme-color") : "#5c5c5c";
  const iconItems = document.getElementsByClassName("icon");
  for (let i = 0; i < iconItems.length; i++) {
    iconItems[i].setAttribute("stroke", themeColor);
  }

  return (
    <li
      className={`sidebarItem relative flex items-center py-2 px-3 my-[16px] font-medium cursor-pointer transition-colors max-h-[50px]
      light:text-links_gray dark:text-[white] hover:text-${
        userData.themeColor
      } hover:border-l-2 hover:border-[${
        localStorage.getItem("theme-color") || userData.themeColor
      }] rounded-none group
    
      ${isActive ? "active" : "notActive"}
      `}
      style={{
        color:
          theme === "light"
            ? localStorage.getItem("theme-color-light") || userData.themeColor
            : localStorage.getItem("theme-color-input") || userData.themeColor,

        borderLeft:
          isActive &&
          `2px solid ${
            theme === "light"
              ? localStorage.getItem("theme-color") || userData.themeColor
              : localStorage.getItem("theme-color-input") || userData.themeColor
          }`,
        "&:hover": {
          color:
            theme === "light"
              ? localStorage.getItem("theme-color") || userData.themeColor
              : localStorage.getItem("theme-color-input") ||
                userData.themeColor,
          borderLeftWidth: "2px",
          borderColor:
            localStorage.getItem("theme-color") || userData.themeColor,
        },
        borderRadius: "0",
        "&.active": {
          color:
            theme === "light"
              ? localStorage.getItem("theme-color") || userData.themeColor
              : localStorage.getItem("theme-color-input") ||
                userData.themeColor,
          borderLeftWidth: "2px",
          borderColor:
            localStorage.getItem("theme-color") || userData.themeColor,
        },
      }}
      onClick={onClick}
    >
      {icon}
      <span
        className={` overflow-hidden transition-all ${
          expanded ? "ml-[15px] z-10" : "w-0"
        } `}
      >
        {text}
      </span>
      {isActive && (
        <div
          className={`absolute right-2 w-2 h-2  rounded  ${
            expanded ? " ml-2" : "top-2"
          }`}
          style={{
            backgroundColor:
              theme === "light"
                ? localStorage.getItem("theme-color-light") ||
                  userData.themeColor
                : localStorage.getItem("theme-color-input") ||
                  userData.themeColor,
          }}
        />
      )}

      {!expanded && (
        <div
          className={`absolute left-full rounded-md px-2 dark:text-black py-1 ml-6 text-white text-sm invisible opacity-20 -translate-x-3 transition-all group-hover:visible group-hover:opacity-100 group-hover:translate-x-0 w-auto min-w-max
          `}
          style={{
            backgroundColor:
              theme === "light"
                ? localStorage.getItem("theme-color-light") ||
                  userData.themeColor
                : localStorage.getItem("theme-color-input") ||
                  userData.themeColor,
          }}
        >
          {text}
        </div>
      )}
    </li>
  );
}
